export default __webpack_public_path__ + "static/media/75_photo.88860289.jpg";